import { FaArrowRight, FaKey, FaRegTrashAlt } from "react-icons/fa";
import { CgProfile } from "react-icons/cg";
import { Tabs, Row, Col, Spin } from 'antd';
import ProfileInfo from './ProfileInfo';
import Trash from './Trash';
import { FaMoneyBillTrendUp } from "react-icons/fa6";
import { MdAppSettingsAlt } from "react-icons/md";
import axios from 'axios';
import Usage from "./Usage";
import CustomizeChat from "./CustomizeChat";
import AdvanceAiParameters from "./AdvanceAiParameters";
import { IntegrateApplications } from "../../component/IntegrateApplications/IntegrateApplications";
import googleDriveIcon from '../../assests/images/google-drive-icon.png';
import { TbPlugConnectedX } from "react-icons/tb"; 
import { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { FileContext } from "../../contexts/FileContext";
import { getGoogleAuthCredentials } from "../../api/googleAuthApi";
import { getWorkBoardAuthCredentials } from "../../api/workBoard";
import { getUserID, getUserRole } from '../../Utility/service';
import AddApiKeyModal from "./AddApiKey";

const userId = getUserID();
const Profile = () => {
  const location = useLocation();
  const [activeKey, setActiveKey] = useState('1');
  const {setIsConnected, setToken,setIsWorkBoardConnected,setWorkBoardToken,isLoading,setIsLoading}=useContext(FileContext);
  useEffect(() => {
    if (location.state?.activeTabKey) {
      setActiveKey(location.state.activeTabKey);
    }
  
  }, [location]);

  const [showHint, setShowHint] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setShowHint(false), 10000); // Hide after 10 sec
    return () => clearTimeout(timer);
  }, []);

  const role = getUserRole();


  const [isModalVisible, setModalVisible] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    Promise.all([
      getGoogleAuthCredentials(userId, setIsConnected, setToken, setIsLoading),
      getWorkBoardAuthCredentials(userId, setIsWorkBoardConnected, setWorkBoardToken)
    ]).finally(() => setIsLoading(false));
  }, []);
  useEffect(() => {
    if (!isLoading) return; // Prevents infinite loop
  
    Promise.all([
      getGoogleAuthCredentials(userId, setIsConnected, setToken, setIsLoading),
      getWorkBoardAuthCredentials(userId, setIsWorkBoardConnected, setWorkBoardToken)
    ]).finally(() => setIsLoading(false));
  }, [isLoading]);
  const items = [
    {
      key: '1',
      label: 'Profile',
      children: <ProfileInfo />,
      icon: <CgProfile />
    },
    {
      key: '2',
      label: 'Trash',
      children: <Trash />,
      icon: <FaRegTrashAlt />
    },
    {
      key: '3',
      label: 'Personal Usage',
      children: <Usage/>,
      icon: <FaMoneyBillTrendUp />
    },
    role === "admin" || role === "superadmin"
      ? {
        key: "4",
        label: "Customize Chat (Beta)",
        children: <CustomizeChat />,
        icon: <MdAppSettingsAlt />,
      }
      : null,
    role === "admin" || role === "superadmin"
      ? {
        key: "6",
        label: "Advanced AI Settings (Beta)",
        children: <AdvanceAiParameters />,
        icon: <FaMoneyBillTrendUp />,
      }
      : null,
    {
        key: '7',
        label: 'Connect Apps',
        children: <IntegrateApplications isLoading={isLoading}/>,
        icon: <TbPlugConnectedX className="large-icon lg" />
      },
  ];
  const handleTabChange = (key) => {
    setIsLoading(true);
    setActiveKey(key);
  };
  return (
    <div>
      <Row className='p-5'>
        <Col span={24}>
        {showHint && (
            <div className="swipe-hint">
              <FaArrowRight size={10} />
              Swipe right to explore
            </div>
          )}
          <Tabs 
            activeKey={activeKey}
            onChange={handleTabChange}
            items={items}
            className="mb-3 custom-tab"
            tabBarStyle={{ justifyContent: 'space-around' }}
          />
        </Col>
      </Row>
    </div>
  );
};

export default Profile;